// Google OAuth configuration
const CLIENT_ID = '884213931610-bo2gq3fmaa7qu4urthkt1etoocb9hv30.apps.googleusercontent.com'; // Replace with your actual client ID
const REDIRECT_URI = 'http://localhost:3000';
const SCOPES = 'https://www.googleapis.com/auth/drive.readonly';

// Generate OAuth URL
const getGoogleAuthUrl = () => {
  const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
  url.searchParams.append('client_id', CLIENT_ID);
  url.searchParams.append('redirect_uri', REDIRECT_URI);
  url.searchParams.append('response_type', 'token');
  url.searchParams.append('scope', SCOPES);
  
  return url.toString();
};

// Initiate Google OAuth flow
const initiateGoogleAuth = () => {
  const authUrl = getGoogleAuthUrl();
  window.location.href = authUrl;
};

// Check if user is authenticated
const isAuthenticated = () => {
  return !!localStorage.getItem('google_access_token');
};

// Get access token from URL after OAuth redirect
const handleAuthRedirect = () => {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  const accessToken = params.get('access_token');
  
  if (accessToken) {
    localStorage.setItem('google_access_token', accessToken);
    return true;
  }
  
  return false;
};

// Logout
const logout = () => {
  localStorage.removeItem('google_access_token');
};

export {
  initiateGoogleAuth,
  isAuthenticated,
  handleAuthRedirect,
  logout
};
